module.exports = __webpack_public_path__ + "static/media/understandingFees.de63806d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/News/Assets/understandingFees.png
// module id = 372
// module chunks = 0